import { Card } from '@app/components/common/Card/Card';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { RoleTable } from '@app/components/tables/RoleTable/RoleTable';
import { Col, Row } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

const RolesPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageTitle>{t('roles.pageTitle')}</PageTitle>
      <Row gutter={[30, 30]}>
        <Col span={24}>
          <Card id="role-form" title={t('roles.title')} padding="1.25rem">
            <RoleTable />
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default RolesPage;
